export default __webpack_public_path__ + "static/media/serverless-azure.b5f5bb5c.png";